namespace advisorop.components.servicer {

    class ServicerModeloperationController {
        public advisorId;
        $router;
        user: domains.identity.IUser;
        show: string = "";
        firmId: number = 0;
        titleSuffix: string = "";
        FundingCashIssuesCount: number;
        ModelCashIssuesCount: number;
        FundingPosnIssuesCount: number;
        OrionModelMonitorIssuesCount: number;

        static $inject = ["identityService", "servicerService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {

        }

        isServicerAdmin(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        }

        $onInit(): void {
            this.advisorId = 1;

            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
        }

        $routerOnActivate(next, previous) {
            this.show = <string>next.params.show;
        }
    }



    class ServicerModeloperation implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ServicerModeloperationController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-modeloperation.html';
        }
    }
    angular.module(Constants.APP).component("servicerModeloperation", new ServicerModeloperation());


}